/**
 * Certificate-related constants and helpers
 */

export const DEFAULT_CERTIFICATE_IMAGE =
  'https://ea.asu.edu/wp-content/uploads/2025/01/AWS-Cloud-Computing_2_image.jpg';

/**
 * Whether a learner has actually earned a certificate.
 *
 * The award is decided in the backend (pok-award-service on credit-conversion
 * approval, plus the credential-awardees cron) and mirrored to Salesforce, so
 * `status` is the answer. Re-deriving it from course progress here produced a
 * dashboard that disagreed with the learner's Credential detail page in both
 * directions. Progress is only a fallback for payloads without a status.
 *
 * @param {Object} certificate - certificate from GET /v2/api/certificates/my-certificates
 * @returns {boolean}
 */
export function isCertificateEarned(certificate) {
  if (!certificate) return false;
  if (certificate.status) return certificate.status === 'completed';

  const { completed = 0, total = 0 } = certificate.progress || {};
  return total > 0 && completed >= total;
}

/**
 * Certificate name for sentences that already say "certificate" — most credential
 * names end with the word, so the sentence would otherwise double it.
 *
 * @param {Object} certificate - certificate from GET /v2/api/certificates/my-certificates
 * @returns {string}
 */
export function certificateSentenceName(certificate) {
  const name = [certificate?.display_label, certificate?.credential_name]
    .map((value) => (typeof value === 'string' ? value.trim() : ''))
    .find(Boolean);
  if (!name) return '';
  return name.replace(/\s+certificate$/i, '');
}
